import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class Footer extends Component {
  render() {
    const { t } = this.props;
    return (
      <footer className="g-bg-main-light-v1">
        <div className="container g-pt-15 g-pb-10">
          <div className="row">
            <div className="col-md-8 text-center text-md-left align-self-center">
              <div className="d-lg-flex align-items-start">
                <div className="d-flex justify-content-center text-nowrap">
                  <span className="g-font-size-14 g-color-gray-dark-v5">
                    2019 &copy; mimiMaps
                  </span>
                </div>

                <div className="d-flex justify-content-center text-nowrap">
                  <span className="g-color-gray-dark-v5 d-none d-lg-block g-mx-10">
                    |
                  </span>
                  <span>
                    <a
                      className="u-link-v5 g-color-gray-dark-v5 g-color-white--hover"
                      href="mailto:info@mimimaps.com.ua"
                    >
                      <i className="fa fa-envelope-o g-mr-5" aria-hidden="true"></i>
                      info@mimimaps.com.ua
                    </a>
                    <br />
                    <a
                      className="
                      u-link-v5
                      g-color-gray-dark-v5
                      g-color-white--hover
                    "
                      href="tel:+380665444363"
                    >
                      <i className="fa fa-phone g-mr-5" aria-hidden="true"></i>
                      +380665444363
                    </a>
                  </span>
                </div>

                <div>
                  <div className="d-flex justify-content-center text-nowrap">
                    <span className="g-color-gray-dark-v5 d-none d-lg-block g-mx-10">
                      |
                    </span>
                    <span className="g-color-gray-dark-v5 text-center text-lg-left">
                      Пн-Пт: 11:00 – 19:00
                      <br />
                    </span>
                  </div>
                </div>
                <div>
                  <div className="d-flex justify-content-center text-nowrap">
                    <span className="g-color-gray-dark-v5 d-none d-lg-block g-mx-10">
                      |
                    </span>
                    <span>
                      <a
                        className="
                          u-link-v5
                          g-color-gray-dark-v5
                          g-color-white--hover
                        "
                        href="/oferta.html"
                      >
                        {t("Договір оферти")}
                      </a>
                      <br />
                      <a
                        className="
                          u-link-v5
                          g-color-gray-dark-v5
                          g-color-white--hover
                        "
                        href="/return.html"
                      >
                        {t("Обмін та повернення")}
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 align-self-center">
              <ul className="list-inline text-center text-md-right mb-0">
                <li
                  className="list-inline-item g-mx-10"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Facebook"
                >
                  <a
                    href="https://www.facebook.com/mimimapsua"
                    target="_blank"
                    className="g-color-white-opacity-0_5 g-color-white--hover"
                  >
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li
                  className="list-inline-item g-mx-10"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Instagram"
                >
                  <a
                    href="https://www.instagram.com/mimimapsua"
                    target="_blank"
                    className="g-color-white-opacity-0_5 g-color-white--hover"
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li
                  className="list-inline-item g-mx-10"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Viber"
                >
                  <a
                    href="viber://chat?number=380665444363"
                    target="_blank"
                    className="g-color-white-opacity-0_5 g-color-white--hover"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/img/viber-logo-grey-vector.svg"
                      }
                      style={{ height: "48px" }}
                    />
                  </a>
                </li>
                <li
                  className="list-inline-item g-mx-10"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Telegram"
                >
                  <a
                    href="https://t.me/mimimapsua"
                    target="_blank"
                    className="g-color-white-opacity-0_5 g-color-white--hover"
                  >
                    <i className="fa fa-telegram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default withTranslation()(Footer);
